import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormikContext } from 'formik'
import { paymentSetData } from 'Checkout/Redux/Actions/Payment'
import Discount from 'Shared/Discount/Discount'

const DiscountWrap = () => {
  const { values: { discount } } = useFormikContext()
  const dispatch = useDispatch()
  const campgroundSlug = useSelector(state => state.campground.slug)
  const reservations = useSelector(state => state.cart.reservations)
  const { from, to } = reservations[0]
  const rateIds = reservations.map(({ rateId }) => rateId)

  useEffect(() => {
    dispatch(paymentSetData({ discount, isNonRefundable: discount.name === 'Non-Refundable' }))
  }, [discount.id])

  return (
    <Discount {...{ campgroundSlug, from, to }} isFloating layoutColumn={{ first: 12, second: 12 }}
              numberRequired={discount.isNumberRequired} rateIds={rateIds} />
  )
}

export default DiscountWrap
